export default "__VITE_ASSET__iCdWVyNk__"